export enum UserAbilities {
    CHANGE_PROJECT_CASEWORKER = 'changeProjectCaseworker',
    EDIT_PROJECT_CUSTOMER_INFO = 'editProjectCustomerInfo',
    CREATE_CLAIM = 'createClaim',
    CANCEL_PROJECT = 'cancelProject',
    CHANGE_PROJECT_INSTALLATION_DATE = 'changeProjectInstallationDate',
    CHANGE_VIDEO_INSPECTION_DATE = 'changeVideoInspectionDate',
    SEE_ADDITIONAL_ELECTRICIAN_JOB_INFO = 'seeAdditionalElectricianJobInfo',
    SEE_JOB_WORK_HOURS = 'seeeJobWorkHours',
    SEE_JOB_MATERIAL_LIST = 'seeJobMaterialList',
    SEE_PROJECT_WORK_HOURS = 'seeProjectWorkHours',
    SEE_MATERIAL_LIST_PRICES = 'seeMaterialListPrices',
    EDIT_TEMPLATE_JOB_IMAGES = 'editTemplateJobImages',
    EDIT_TEMPLATE_JOB_MATERIAL_LIST = 'editTemplateJobMaterialList',
    CHANGE_PHYSICAL_INSPECTION_DATE = 'changePhysicalInspectionDate',
    COMPLETE_PHYSICAL_INSPECTION = 'completePhysicalInspection',
    CREATE_OFFER_FROM_VIDEO_INSPECTION = 'createOfferFromVideoInspection',
    MARK_APPLICATION_AS_SENT = 'markApplicationAsSent',
    MARK_APPLICATION_AS_APPROVED_OR_DECLINED = 'markApplicationAsApprovedOrDeclined',
    COMPLETE_PROJECT = 'completeProject',
    SEE_PROJECT_ACTIVITY_LOG = 'seeProjectActivityLog',
    SEE_EVALUATION_SUMMARY = 'seeEvaluationSummary',
    SEE_JOB_COMMENT_FOR_ELECTRICIAN = 'seeJobCommentForElectrician',
    STOP_PRE_PAYMENT_PROCESS = 'stopPrePaymentProcess',
    FILTER_PROJECTS_BY_CONTRACTOR = 'filterProjectsByContractor',
    FILTER_PROJECTS_BY_ELECTRICIAN = 'filterProjectsByElectrician',
    FILTER_PROJECTS_BY_CASEWORKER = 'filterProjectsByCaseworker',
    FILTER_PROJECTS_BY_STAGE_AND_STATUS = 'filterProjectsByStageAndStatus',
    SORT_PROJECTS_TABLE = 'sortProjectsTable',
    CHANGE_PROJECT_ELECTRICIAN = 'changeProjectElectrician',
    CREATE_PROJECT = 'createProject',
    EDIT_PROJECT_ELECTRICIAN_INFO = 'editProjectElectricianInfo',
    EDIT_CUSTOMER_INFO = 'editCustomerInfo',
    MODIFY_PROJECT_SELLER = 'modifyProjectSeller',
    MAKE_CHANGES_TO_INITIAL_ORDER = 'makeChangesToInitialOrder',
    SYNC_PROJECT_SALE = 'syncProjectSale',
}

export type UserAbilitiesObject = { [value in UserAbilities]: boolean };
